/* NORTHBITE Kaufbox v27 (snippets/nb-buybox.liquid): Kaufart, Laufzeit, Dosenzahl,
   Preis und Button. Preise und Abo-Preise kommen aus dem Shop. Die Staffel gilt nur für den Einmalkauf, im Abo gilt nur der Abo-Rabatt
   (data-tiers, "Menge:Prozent") muss zu den automatischen Rabatten im
   Shopify-Admin passen: dort wird im Warenkorb wirklich abgezogen.
   Vorbestell-Modus (data-preorder="true"): Es wird die kostenlose Vorbestell-Variante
   mit der Dosenzahl als Menge bestellt. Kaufart und voraussichtlicher Preis gehen als
   Positions-Eigenschaften mit. Der Warenkorb wird vorher geleert, danach geht es direkt
   zur Kasse.
   Die ältere Kaufbox der Produktseite rechnet weiter in northbite-buy.js. */
(function () {
  function money(cents, cur) {
    try { return (cents / 100).toLocaleString('de-AT', { style: 'currency', currency: cur, minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
    catch (e) { return (cents / 100).toFixed(2).replace('.', ',') + ' ' + cur; }
  }
  function parseGrams(title, fallbackGrams) {
    var m = /(\d+(?:[.,]\d+)?)\s*(g|kg)\b/i.exec(title || '');
    if (!m) return fallbackGrams;
    var g = parseFloat(m[1].replace(',', '.'));
    return m[2].toLowerCase() === 'kg' ? g * 1000 : g;
  }
  function parseTiers(str) {
    return String(str || '').split(',').map(function (t) { var a = t.split(':'); return { min: parseInt(a[0], 10), pct: parseFloat(a[1]) }; })
      .filter(function (t) { return t.min > 0 && t.pct > 0; }).sort(function (a, b) { return a.min - b.min; });
  }
  function planPrice(base, type, value) {
    if (type === 'percentage') return Math.round(base * (1 - value / 100));
    if (type === 'fixed_amount') return Math.max(0, base - value);
    if (type === 'price') return value;
    return base;
  }
  function clean(t) { return String(t || '').replace(/\s+/g, ' ').trim(); }
  function init(root) {
    if (root.__nb) return; root.__nb = true;
    var d = root.dataset;
    var pre = d.preorder === 'true';
    var cur = d.currency || 'EUR';
    var unit = parseInt(d.unitPrice, 10) || 0;
    var grams = parseGrams(d.unitTitle, parseFloat(d.grams) || 800);
    var tiers = parseTiers(d.tiers);
    var maxQ = parseInt(d.max, 10) || 99;
    function q1(sel) { return root.querySelector(sel); }
    var planIn = q1('[data-nb-plan]'), vid = q1('[data-nb-vid]');
    var pMode = q1('[data-nb-p-mode]'), pPrice = q1('[data-nb-p-price]');
    var priceEl = q1('[data-nb-price]'), wasEl = q1('[data-nb-was]'), perEl = q1('[data-nb-per]');
    var unitLine = q1('[data-nb-unitline]'), saveEl = q1('[data-nb-save]'), baseEl = q1('[data-nb-base]');
    var btnText = q1('[data-nb-btntext]'), submit = q1('[data-nb-submit]');
    var oneUnit = q1('[data-nb-oneunit]'), subUnit = q1('[data-nb-subunit]'), badge = q1('[data-nb-badge]');
    var terms = q1('[data-nb-terms]'), abo = q1('[data-nb-abo]');
    var qtyIn = q1('[data-nb-qty]'), qtyBox = q1('[data-nb-qtybox]');
    var dec = q1('[data-nb-qdec]'), inc = q1('[data-nb-qinc]');
    var picks = Array.prototype.slice.call(root.querySelectorAll('[data-nb-pick]'));
    var plans = Array.prototype.map.call(root.querySelectorAll('[data-nb-planopt]'), function (inp) {
      var label = root.querySelector('label[for="' + inp.id + '"]');
      return { inp: inp, label: label, pctEl: label ? label.querySelector('[data-nb-planpct]') : null, type: inp.dataset.type, value: parseFloat(inp.dataset.value) || 0 };
    });
    var soldOut = !!(submit && submit.disabled);

    function clamp(q) { q = parseInt(q, 10); if (!q || q < 1) q = 1; if (q > maxQ) q = maxQ; return q; }
    function qty() { var q = clamp(qtyIn ? qtyIn.value : 1); if (qtyIn && String(q) !== qtyIn.value) qtyIn.value = q; return q; }
    function setQty(q) { if (qtyIn) qtyIn.value = clamp(q); update(); }
    function tierFor(q) { var hit = null; tiers.forEach(function (x) { if (q >= x.min) hit = x; }); return hit; }
    /* Dosenpreis wie bei Shopify: Der Mengenrabatt wird je Dose abgezogen und dabei
       auf ganze Cent abgerundet (5,90 € − 5 % = 5,61 €). */
    function canPrice(unitPrice, q) { var tr = tierFor(q); return tr ? unitPrice - Math.floor(unitPrice * tr.pct / 100) : unitPrice; }
    function mode() { var m = root.querySelector('[data-nb-mode]:checked'); return m ? m.value : 'one'; }
    function currentPlan() { var c = root.querySelector('[data-nb-planopt]:checked'); return plans.filter(function (p) { return p.inp === c; })[0] || plans[0]; }

    if (dec) dec.addEventListener('click', function () { setQty(qty() - 1); });
    if (inc) inc.addEventListener('click', function () { setQty(qty() + 1); });
    picks.forEach(function (b) { b.addEventListener('click', function () { setQty(parseInt(b.dataset.nbPick, 10)); }); });

    /* Abo-Rabatt je Plan und der höchste davon: aus den Preisen des Shops, nicht aus dem Theme */
    var bestPct = 0;
    plans.forEach(function (p) {
      var pp = planPrice(unit, p.type, p.value), pct = unit > 0 ? Math.round((unit - pp) / unit * 100) : 0;
      p.pct = pct;
      if (pct > bestPct) bestPct = pct;
      if (p.pctEl) p.pctEl.textContent = pct > 0 ? '−' + pct + ' %' : '';
    });
    if (badge && d.badge) { badge.textContent = d.badge.replace('[x]', bestPct); badge.hidden = bestPct <= 0; }

    function update() {
      var q = qty(), sub = mode() === 'sub' && plans.length > 0;
      var full = unit * q, oneCan = canPrice(unit, q);
      /* Dosenpreise an den beiden Karten für die gewählte Menge */
      var minSub = null;
      plans.forEach(function (p) { var c = planPrice(unit, p.type, p.value); if (minSub === null || c < minSub) minSub = c; });
      if (oneUnit) oneUnit.textContent = money(oneCan, cur);
      if (subUnit && minSub !== null) subUnit.textContent = money(minSub, cur);
      if (terms) terms.hidden = !sub;
      if (abo) abo.classList.toggle('is-on', sub);
      var p = sub ? currentPlan() : null;
      var can = p ? planPrice(unit, p.type, p.value) : oneCan; /* Abo: nur Abo-Rabatt, kein Mengenrabatt (seit 17.10.2026) */
      var total = can * q;
      if (planIn) { if (p) { planIn.value = p.inp.value; planIn.disabled = false; } else { planIn.value = ''; planIn.disabled = true; } }
      if (dec) dec.disabled = q <= 1;
      if (inc) inc.disabled = q >= maxQ;
      picks.forEach(function (b) { var on = parseInt(b.dataset.nbPick, 10) === q; b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false'); });
      if (priceEl) priceEl.textContent = money(total, cur);
      if (wasEl) { if (total < full) { wasEl.textContent = money(full, cur); wasEl.hidden = false; } else wasEl.hidden = true; }
      if (perEl) perEl.hidden = !p;
      if (unitLine) unitLine.textContent = q + ' × ' + grams + ' g · ' + money(can, cur) + ' ' + (d.unitSuffix || 'pro Dose');
      if (saveEl) {
        if (total < full) { saveEl.textContent = (d.save || 'Du sparst') + ' ' + money(full - total, cur) + (p && d.per ? ' ' + d.per : ''); saveEl.hidden = false; }
        else saveEl.hidden = true;
      }
      if (baseEl) baseEl.textContent = 'Grundpreis ' + money(total / (q * grams) * 1000, cur) + ' / kg · ';
      if (btnText && !soldOut) btnText.textContent = pre ? (d.ctaOne || 'Kostenlos vorbestellen') : (p ? (d.ctaSub || 'Monats-Abo starten') : (d.ctaOne || 'Jetzt bestellen'));
      /* Vorbestellung: Kaufart und Preis als Eigenschaften der Position */
      if (pre) {
        var kind = 'Einmalkauf';
        if (p) {
          var tt = p.label ? clean((p.label.querySelector('.nb-bx__term-t') || {}).textContent) : '';
          var ts = p.label ? clean((p.label.querySelector('.nb-bx__term-s') || {}).textContent) : '';
          kind = (d.subTitle || 'Abo') + (tt ? ' – ' + tt : '') + (ts ? ' (' + ts + ')' : '');
        }
        if (pMode) pMode.value = kind;
        if (pPrice) pPrice.value = money(total, cur) + (p ? ' je Lieferung' : '') + ' (' + q + ' × ' + money(can, cur) + ')';
      }
      document.dispatchEvent(new CustomEvent('ew:variant', { detail: { id: vid ? vid.value : '', price: money(total, cur), plan: p ? p.inp.value : '', qty: q } }));
    }
    root.addEventListener('change', update);
    if (qtyIn) qtyIn.addEventListener('input', function () { if (qtyIn.value !== '') update(); });
    /* Futterrechner: berechnete Dosenzahl übernehmen */
    document.addEventListener('ew:selectvariant', function (e) {
      if (!e.detail || !e.detail.qty) return;
      setQty(e.detail.qty);
      if (qtyBox) { qtyBox.classList.add('is-flash'); setTimeout(function () { qtyBox.classList.remove('is-flash'); }, 1600); }
    });

    /* Vorbestellung absenden: Warenkorb leeren, Vorbestellung hinein, direkt zur Kasse.
       Klappt etwas nicht, wird das Formular normal abgeschickt (geht über return_to
       ebenfalls zur Kasse). */
    if (pre) {
      root.addEventListener('submit', function (e) {
        if (!window.fetch || !vid) return;
        e.preventDefault();
        update();
        if (submit) { submit.disabled = true; submit.classList.add('is-busy'); }
        var props = {};
        Array.prototype.forEach.call(root.querySelectorAll('input[name^="properties["]'), function (i) { props[i.name.slice(11, -1)] = i.value; });
        var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        var json = { 'Content-Type': 'application/json', Accept: 'application/json' };
        fetch(base + 'cart/clear.js', { method: 'POST', headers: json, credentials: 'same-origin' })
          .then(function () {
            return fetch(base + 'cart/add.js', { method: 'POST', headers: json, credentials: 'same-origin', body: JSON.stringify({ items: [{ id: parseInt(vid.value, 10), quantity: qty(), properties: props }] }) });
          })
          .then(function (r) { if (!r.ok) throw new Error('cart'); window.location.href = base + 'checkout'; })
          .catch(function () {
            if (submit) { submit.disabled = false; submit.classList.remove('is-busy'); }
            HTMLFormElement.prototype.submit.call(root);
          });
      });
    }
    update();
  }
  function run() { Array.prototype.forEach.call(document.querySelectorAll('[data-nb-buy]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  document.addEventListener('shopify:section:load', run);
})();